module.exports = __webpack_public_path__ + "static/media/ex7-slow.3ef521f7.mp3";